import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
function Flex({
  children,
  direction = "row",
  wrap = "nowrap",
  justifyContent = "flex-start",
  alignItems = "stretch",
  gap,
  ...props
}) {
  return /* @__PURE__ */ jsx(FlexStyled, {
    $direction: direction,
    $wrap: wrap,
    $justifyContent: justifyContent,
    $alignItems: alignItems,
    $gap: gap,
    ...props,
    children
  });
}
const FlexStyled = styled.div.withConfig({
  displayName: "FlexStyled",
  componentId: "sc-duap7b-0"
})(["display:flex;flex-direction:", ";flex-wrap:", ";gap:", ";justify-content:", ";align-items:", ";box-sizing:border-box;width:100%;height:100%;"], (props) => props.$direction, (props) => props.$wrap, (props) => props.$gap ? token[`spacing${props.$gap}`] : void 0, (props) => props.$justifyContent, (props) => props.$alignItems);
export {
  Flex
};
//# sourceMappingURL=Flex.js.map
